import { useQuery } from '@apollo/client';
import { ChangeLanguage } from 'components/site/forms/ChangeLanguage';
import { ChangePasswordForm } from 'components/site/forms/ChangePasswordForm';
import { SubscriptionPageContent } from 'components/site/pages/SubscriptionPageContent';
import { OptionRowValue } from 'elements/minute/sidebar/sidebarComponents/atomic/OptionRowValue';
import { CurrentUser } from 'graphql/query/__generated__/CurrentUser';
import { CURRENT_USER_QUERY } from 'graphql/query/userQuery';
import { EBorders, EFonts } from 'libs/styles/styling';
import { useState } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MyAccountPageContent = (props: Props): JSX.Element => {
    const query = useQuery<CurrentUser>(CURRENT_USER_QUERY);
    const [index, setIndex] = useState(0);
    const user = query.data?.currentUser;

    if (!user) {
        return null;
    }

    return (
        <S_MyAccountPageContent className={props.className}>
            <S_Center>
                <OptionRowValue
                    items={[
                        { text: Localization.SUBSCRIPTION },
                        { text: Localization.PASSWORD },
                        { text: Localization.LANGUAGE }
                    ]}
                    selectedIndex={index}
                    onSelected={(newIndex) => {
                        setIndex(newIndex);
                    }}
                />
            </S_Center>
            <S_Line />
            <S_Mid>
                {index === 0 && <S_SubscriptionPageContent />}
                {index === 1 && (
                    <>
                        {user.hasPassword && <S_ChangePasswordForm />}
                        {!user.hasPassword && <S_Desc>{Localization.YOU_HAVE_NO_PASSWORD}</S_Desc>}
                    </>
                )}
                {index === 2 && <S_ChangeLanguage />}
            </S_Mid>
        </S_MyAccountPageContent>
    );
};

const S_MyAccountPageContent = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${EBorders.DARK};
    border-radius: 7px;
`;

const S_Center = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px;
`;

const S_Line = styled.div`
    height: 1px;
    background-color: #d3d3d3;
    width: 100%;
`;

const S_Mid = styled.div`
    display: flex;
    justify-content: center;
`;

const S_ChangePasswordForm = styled(ChangePasswordForm)`
    padding: 20px;
`;

const S_SubscriptionPageContent = styled(SubscriptionPageContent)`
    padding: 20px;
`;

const S_Desc = styled.div`
    padding: 20px;
    font-size: 15px;
    font-family: ${EFonts.Medium};
`;

const S_ChangeLanguage = styled(ChangeLanguage)`
    padding: 20px;
`;
